import styled from 'styled-components';
import { DropdownInput } from '../../baseInputs/DropdownInput';
import { useScene } from '../../../../context/sceneContext';

export const WindowHandleVariableInput = () => {
  const scene = useScene();

  const data = scene.getSelectedElementsData(
    {
      ['-webkit-app-region']: undefined,
    },
    'props.class'
  );

  return (
    <Row>
      <DropdownInput
        label="Window Drag Handle"
        value={data['-webkit-app-region']}
        options={[
          { label: 'Yes', value: 'drag' },
          { label: 'No', value: undefined },
        ]}
        onChange={(newValue) =>
          scene.updateSelectedElementsData({ ['-webkit-app-region']: newValue }, 'props.class', 'windowHandleVariableInput')
        }
        canBeCleared={false}
        isSearchable={false}
      />
    </Row>
  );
};

const Row = styled.div`
  width: 100%;
  display: flex;
`;
